export enum MountHeightPossibilityMark {
  POSSIBLE = 'POSSIBLE',
  NOT_IDEAL = 'NOT_IDEAL',
  NOT_POSSIBLE = 'NOT_POSSIBLE',
}
